import { useEffect } from 'react';
import { toast } from 'sonner';
import { getCrew, calDue, calSoon, calNext } from '../lib/crew';

// once per day at app start: devices whose calibration expired or expires within 30 days
const KEY = 'giss_calib_seen';
export default function CalibReminder({ t }) {
  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    if (localStorage.getItem(KEY) === today) return undefined;
    const id = setTimeout(() => {
      const list = getCrew().devices.filter((d) => calDue(d) || calSoon(d));
      if (!list.length) return;
      const line = (d) => `${d.type}${d.serial ? ` (${d.serial})` : ''}: ${calDue(d) ? t.wlCalDue : t.crSoon} ${calNext(d).toLocaleDateString(t.locale)}`;
      toast.warning(t.crTitle, {
        id: 'calib-reminder', duration: 20000, className: 'calib-toast',
        description: <div data-testid="calib-reminder">{list.map((d) => <div key={d.id} data-testid={`calib-reminder-${d.id}`}>{line(d)}</div>)}</div>,
        action: { label: t.crOk, onClick: () => localStorage.setItem(KEY, today) },
      });
    }, 3000);
    return () => clearTimeout(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
